const SUITS = ['s', 'h', 'd', 'c']; // spades, hearts, diamonds, clubs
const RANKS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]; // A-K

export function createDeck() {
  const cards = [];
  let id = 0;
  for (const suit of SUITS) {
    for (const rank of RANKS) {
      cards.push({ id: id++, suit, rank, isJoker: false });
    }
  }
  return cards;
}

export function shuffle(deck) {
  const out = [...deck];
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out;
}

export function deal(deck, numPlayers, cardsPerPlayer = 10) {
  const shuffled = shuffle(deck);
  const hands = Array.from({ length: numPlayers }, () => []);
  let idx = 0;
  for (let i = 0; i < cardsPerPlayer; i++) {
    for (let p = 0; p < numPlayers; p++) {
      if (shuffled[idx]) hands[p].push(shuffled[idx]);
      idx++;
    }
  }
  const remaining = shuffled.slice(numPlayers * cardsPerPlayer);
  return { hands, remaining };
}

export function cardLabel(card) {
  if (card.isJoker) return 'Joker';
  const r = card.rank;
  const rankStr = r === 1 ? 'A' : r === 11 ? 'J' : r === 12 ? 'Q' : r === 13 ? 'K' : String(r);
  const suitStr = { s: '♠', h: '♥', d: '♦', c: '♣' }[card.suit] || '';
  return rankStr + suitStr;
}

export function cardRankValue(rank) {
  if (rank === 'joker') return null;
  return rank;
}
